import React from "react";
import {
  SideNavItem as SideNavItemStyle,
  ImageContainer,
  ContentContainer,
  NameDiv,
  NewMessageDiv,
  // ImageDiv,
} from "./style";

const SideNavItem = (props) => {
  return (
    <SideNavItemStyle {...props}>
      {/* <ImageDiv> */}
      <ImageContainer>
        <img src={props.icon} alt="profile-image" />
      </ImageContainer>
      {/* </ImageDiv> */}
      <ContentContainer>
        <NameDiv>{props.name}</NameDiv>
        {props.newMessageCount > 0 ? (
          <NewMessageDiv>{props.newMessageCount} new messages</NewMessageDiv>
        ) : (
          props.message
        )}
      </ContentContainer>
    </SideNavItemStyle>
  );
};

export default SideNavItem;
